import Vue from 'vue'
import VueRouter from 'vue-router'
// https://github.com/declandewet/vue-meta
// import VueMeta from 'vue-meta'
import NProgress from 'nprogress/nprogress'
import store from '@store'
import routes from './routes'
import VueMeta from 'vue-meta'

import { Trans } from '@utils/translation'
import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import { ro } from 'date-fns/locale'
// import {trackService} from '@utils/trackService'

Vue.use(VueMeta, {
  keyName: 'page',
})

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if(to.hash) {
        return {
          selector: to.hash
        }
      } else {
        return { x: 0, y: 0 }
      }
    }
  },
});

router.beforeEach(async (routeTo, routeFrom, next) => {
  if (routeTo.meta.isNullPage) {
    return next()
  } else {
    const startNProgress = () => {
      if (routeFrom.name !== null) {
        NProgress.start()
      }
    };

    const setScrollRestoration = () => {
      if ('scrollRestoration' in history) {
        history.scrollRestoration = routeTo.meta.notScrollRestoration
          ? 'manual'
          : 'auto'
      }
    };

    const checkLoginPage = () => {
      const isLoginPage = routeTo.matched.some((route) => route.meta.isLoginPage);

      if (isLoginPage && !(isLoginPage && store.getters['auth/loggedIn'])) {
        return next({ path: '/login', query: { redirectFrom: routeTo.fullPath }, replace: true })
      }
    };

    const checkLogoutPage = () => {
      const isLogoutPage = routeTo.matched.some((route) => route.meta.isLogoutPage);

      if (isLogoutPage && !(isLogoutPage && !store.getters['auth/loggedIn'])) {
        return next({ path: '/member' })
      }
    };

    const checkMenu = async () => {
      let menuData = window.sessionStorage.getItem("menu")
      let checkFlag =
              menuData?
                 new Date() - new Date(JSON.parse(menuData).getTime) >= 28800000:true // 28800000為8小時 若距離上次取得時間超過8小時重新取得
      if(checkFlag){
        let menu = await store.dispatch('global/fetchMenu')
        let data = {
          menu: menu,
          getTime: new Date()
        }
        window.sessionStorage.setItem("menu", JSON.stringify(data))
      }
    }

    // const tryToFetchSetting = () => {
    //   return store.dispatch('global/fetchSetting')
    // };

    const jsonMenuData = window.sessionStorage.getItem("menu")
    if(jsonMenuData && routeTo.meta.alias){
      const menuData = JSON.parse(jsonMenuData)
      let checkFlag = menuData.menu.items.find((item) => {
        return item.alias === routeTo.meta.alias
      })
      const checkCurrentUser = window.localStorage.getItem('auth.currentUser')
      if(checkFlag && checkCurrentUser){
        const recordMenuLog = async () => {
          await store.dispatch('global/recordMenuLog', routeTo.meta.alias)
        }
        recordMenuLog()
      }
    }

    startNProgress();
    setScrollRestoration();

    checkLoginPage();
    checkLogoutPage();

    checkMenu()

    // await tryToFetchSetting();

    return next()
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              if (routeFrom.name === args[0].name) {
                NProgress.done()
              }

              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    }
  } catch (error) {
    return
  }

  next()
})

router.afterEach((routeTo, routeFrom) => {
  NProgress.done()

  // const trackService = () => {
  //   const { meta } = routeTo
  //   const pageTitle = meta.title || store.state.global.currentSetting.sitename
  //   Vue.gtm.trackEvent({
  //     // 自行定義的事件名稱
  //     event: 'page_view',
  //     // 頁面功能/分頁標題文字
  //     pageTitle: pageTitle
  //   })
  // }
  // // 時間稍微延遲以避免抓取到前個 window.location.href 位置
  // setTimeout(() => {
  //   trackService()
  // }, 500)
})


export default router
